import axios from 'axios';
import { api } from './firebase';

export const cleanText = async (text: string): Promise<string> => {
  const res = await axios.get(`${api}/cleantext/?msg=${text}`);
  return res.data.cleanText;
};

//old ways
// export const cleanText = async (text: string): Promise<boolean> => {
//   const api = ` https://www.gsbschoolbank.com/api/filterlanguage/?msg=${text}`;
//   const res = await fetch(api, {
//     headers: { 'Access-Control-Allow-Origin': '*' },
//   });
//   return (await res.json()) as boolean;
// };
